"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIZARD_ACTIONS_ID = void 0;
exports.WIZARD_ACTIONS_ID = {
    prev: 'prev',
    next: 'next',
    skip: 'skip',
    done: 'done',
    cancel: 'cancel',
};
//# sourceMappingURL=wizardActionsId.js.map